// ======================================================================
// File Name       : userAttribute
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

export const USER_ATTRIBUTE_RECEIVE_LIST = 'USER_ATTRIBUTE_RECEIVE_LIST';
export const USER_ATTRIBUTE_RECEIVE_EDITING = 'USER_ATTRIBUTE_RECEIVE_EDITING';
export const USER_ATTRIBUTE_INIT_EDITING = 'USER_ATTRIBUTE_INIT_EDITING';
